import Vue from 'vue'
import App from './App.vue'
import WPAPI from 'wpapi'

Vue.config.productionTip = false
Vue.prototype.$wp = new WPAPI({endpoint: 'https://kidsmile.anvetogroup.com/wp-json'})

new Vue({
  render: h => h(App),
}).$mount('#app')
